import { make } from 'vuex-pathify'

// import dottie from 'dottie'
// import { api } from '@/api'

/**
 * semantics try align with DDD
 * @see https://www.thenativeweb.io/blog/2017-10-25-09-46-ddd-and-co-part-1-whats-wrong-with-crud/
 * */

// like: initial state
const state = {
  config: {
    name: 'default',
    steps: [1, 2, 3, 4, 5]
  }
}

// like: aggregated state
const getters = {
  ...make.getters(state)
}

// like: fires events
const mutations = {
  ...make.mutations(state)
}

// like: commands
const actions = {}

// like: domain
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
